export { default } from './support-v2-categories-page';
